<div class="ion-text-center position-relative pt-64 help-header">
  <button type="button" class="back-arrow-header" [attr.aria-label]="'a11y.back' | translate" (click)="back()" *ngIf="showBackButton">
    <img src="assets/back_arrow_new.svg" alt="" />
  </button>
  <img [class]="logoClass" [src]="logoSrc" [attr.alt]="'a11y.logo' | translate" />
  <button type="button" class="help-icon" [attr.aria-label]="'a11y.help' | translate" (click)="openHelpCenter()">
    <ion-icon name="help-circle-outline" aria-hidden="true"></ion-icon>
  </button>
</div>
